
import { SubjectSelector, SubjectTypeSelector,
         ProgramSelector,
         FeatureTypeSelector } from "@Beasted1010/pivotal-wisdom";


// TODO: Move to a type file... ?
interface IFetchUpdateOptions {
  userId?: string,

  subjectSelector?: SubjectSelector,
  programSelector?: ProgramSelector,
  featureSelector?: FeatureTypeSelector,

  type?: SubjectTypeSelector,
  userProgressType?: string,

  data?: any,

  signal?: AbortSignal
}


async function fetchUpdateUserProgress( {subjectSelector, programSelector, featureSelector, userProgressType, data, signal}: IFetchUpdateOptions ) {

  const queryParams = userProgressType ? `?type=${userProgressType}` : "";
  const URL = `/api/v1/progress/${subjectSelector}/${programSelector}/${featureSelector}${queryParams}`;

  const response = await fetch( URL, {
    signal,

    credentials: "include", // Include Cookies in Cross Origin Requests (TODO: May not need this once FrontEnd and BackEnd merged since FE is on Port 3000 and BE is on 7777, thus 'different Origins')

    method: "POST",

    headers: {
      "Content-Type": "application/json"
    },

    body: JSON.stringify(data),
  });

  const responseData = await response.json();
  const userProgress = responseData.userProgress;

  return userProgress;
}






export {
  fetchUpdateUserProgress,
}
